import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Paper, Typography, Box, Chip } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const AdminTest: React.FC = () => {
  const { currentUser, isAdmin } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <img 
            src="/milestone-logo.svg" 
            alt="Milestone" 
            className="h-12 w-auto mx-auto mb-4"
          />
          <h1 className="text-2xl font-medium text-[#0099da]">Admin Test Page</h1>
        </div>

        <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <AdminPanelSettingsIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Admin Access Verified ✅
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              You successfully accessed the admin area!
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              User Information:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                  Email:
                </Typography>
                <Typography variant="body1">
                  {currentUser?.email || 'Not available'}
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                  Admin Status:
                </Typography>
                <Chip 
                  label={isAdmin ? "Admin User" : "Regular User"}
                  color={isAdmin ? "success" : "default"}
                  variant="outlined"
                />
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                  User ID:
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>
                  {currentUser?.uid || 'Not available'}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{ p: 2, bgcolor: 'success.light', borderRadius: 1 }}>
            <Typography variant="body2" sx={{ color: 'success.dark' }}>
              🎉 Congratulations! The role-based access control is working correctly. 
              Only users with the `admin: true` custom claim can see this page.
            </Typography>
          </Box>
        </Paper>
      </div>
    </div>
  );
};

export default AdminTest; 